"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class GatewayTrustList extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gatewayTrustList';
        this._trustList = (0, util_1.camelArray)(initParams.trust_list);
    }
    set trustList(value) {
        console.error('Do not set objects this way');
    }
    get trustList() {
        return this._trustList;
    }
}
exports.default = GatewayTrustList;
//# sourceMappingURL=gatewayTrustList.js.map